// Dependencies
import Translate from '@/filters/translate'
import PosterMixin from '@/mixins/posterMixin'

// Components
import HangingFrame from '@/components/hanging-frame/component'
import DropDown from '@/components/dropdown/component'
import Usps from '@/components/usps/component'
import ArtistHero from '@/components/artist-hero/component'
import ArtistHeroVideo from '@/components/artist-hero-video/component'
import OurArtists from '@/components/our-artists/component'

// Poster SVGs
// Ingela P. Arrhenius.
import Babyroo from '@/components/posters/babyroo/component'
import BornStrong from '@/components/posters/born-strong/component'
import FoxyStrollin from '@/components/posters/foxy-strollin/component'
import Peekaboo from '@/components/posters/peekaboo/component'
import Mockingbird from '@/components/posters/mockingbird/component'
import OwlinForYou from '@/components/posters/owlin-for-you/component'
import RetroBaby from '@/components/posters/retro-baby/component'
import ScandinavianForest from '@/components/posters/scandinavian-forest/component'
import WhatTheFoxSay from '@/components/posters/what-the-fox-say/component'
import ShortyAndStretch from '@/components/posters/shorty-and-stretch/component'

// Peytil.
import Adorable from '@/components/posters/adorable/component'
import Playful from '@/components/posters/playful/component'
import Delightful from '@/components/posters/delightful/component'
import Rosette from '@/components/posters/rosette/component'

// Katarzyna Stróżyńska Goraj.
import BlossomA from '@/components/posters/blossom-a/component'
import BlossomB from '@/components/posters/blossom-b/component'
import BlossomC from '@/components/posters/blossom-c/component'
import BlossomD from '@/components/posters/blossom-d/component'
import BlossomE from '@/components/posters/blossom-e/component'
import BlossomF from '@/components/posters/blossom-f/component'
import BlossomG from '@/components/posters/blossom-g/component'
import BlossomH from '@/components/posters/blossom-h/component'
import BlossomI from '@/components/posters/blossom-i/component'
import BlossomJ from '@/components/posters/blossom-j/component'
import BlossomK from '@/components/posters/blossom-k/component'
import BlossomL from '@/components/posters/blossom-l/component'
import BlossomM from '@/components/posters/blossom-m/component'
import BlossomN from '@/components/posters/blossom-n/component'
import BlossomO from '@/components/posters/blossom-o/component'
import BlossomP from '@/components/posters/blossom-p/component'
import BlossomQ from '@/components/posters/blossom-q/component'
import BlossomR from '@/components/posters/blossom-r/component'
import BlossomS from '@/components/posters/blossom-s/component'
import BlossomT from '@/components/posters/blossom-t/component'
import BlossomU from '@/components/posters/blossom-u/component'
import BlossomV from '@/components/posters/blossom-v/component'
import BlossomW from '@/components/posters/blossom-w/component'
import BlossomX from '@/components/posters/blossom-x/component'
import BlossomY from '@/components/posters/blossom-y/component'
import BlossomZ from '@/components/posters/blossom-z/component'
import BlossomAring from '@/components/posters/blossom-aring/component'
import BlossomAuml from '@/components/posters/blossom-auml/component'
import BlossomOuml from '@/components/posters/blossom-ouml/component'
import BlossomAelig from '@/components/posters/blossom-aelig/component'
import BlossomOslash from '@/components/posters/blossom-oslash/component'
import BlossomYuml from '@/components/posters/blossom-yuml/component'
// Single view for all posters
import Draupadia from '@/components/posters/draupadia/component'
import CustomerQuotes from '@/components/customer-quotes/component'

export default {
  name: 'poster-page',
  mixins: [ PosterMixin ],
  data () {
    return {
      loaded: false,
      nonLatinWarningNaturalHeight: 0,
      adding: false,
      selectedColor: { name: '', color: '' },
      showCustomizePoster: false
    }
  },

  props: ['poster', 'color', 'colorName', 'presentation', 'list', 'position'],

  components: {
    // Components
    HangingFrame,
    DropDown,
    Usps,
    ArtistHero,
    ArtistHeroVideo,
    OurArtists,
    CustomerQuotes,

    // Posters
    Babyroo,
    BornStrong,
    FoxyStrollin,
    Peekaboo,
    Mockingbird,
    OwlinForYou,
    RetroBaby,
    ScandinavianForest,
    WhatTheFoxSay,
    ShortyAndStretch,
    Adorable,
    Playful,
    Delightful,
    Rosette,
    BlossomA,
    BlossomB,
    BlossomC,
    BlossomD,
    BlossomE,
    BlossomF,
    BlossomG,
    BlossomH,
    BlossomI,
    BlossomJ,
    BlossomK,
    BlossomL,
    BlossomM,
    BlossomN,
    BlossomO,
    BlossomP,
    BlossomQ,
    BlossomR,
    BlossomS,
    BlossomT,
    BlossomU,
    BlossomV,
    BlossomW,
    BlossomX,
    BlossomY,
    BlossomZ,
    BlossomAring,
    BlossomAuml,
    BlossomOuml,
    BlossomAelig,
    BlossomOslash,
    BlossomYuml,
    Draupadia
  },

  beforeMount () {
    let self = this
    let componentFound = false
    Object.entries(this.$options.components).forEach(function (c) {
      if (c[0].toLowerCase() === self.poster.replace(/-/g, '')) {
        componentFound = true
      }
    })

    if (!componentFound) {
      this.$router.push({ name: 'notFound' })
    }

    if (this.$route.name !== 'poster') {
      const _this = this
      if (_this.presentation) {
        const presentation = this.$store.getters.posterPresentations.find(function (item) {
          return item.value.toLowerCase() === _this.presentation.replace('-', '').toLowerCase()
        })
        if (presentation) {
          this.setPresentation(presentation)
        }
      }
      if (_this.colorName) {
        const color = this.metaData.colors.find(function (color) {
          return color.name.toLowerCase() === _this.colorName.toLowerCase()
        })
        if (color) {
          this.selectedColor = color
        }
      }

      this.$router.replace({
        name: 'poster',
        params: {
          poster: this.poster,
          color: this.selectedColor
        }
      })
    }

    // @todo What about errors?
    this.$store.dispatch('setPoster', this.poster)
    // this.$store.dispatch('setPosterLanguage', this.$store.getters.getCurrLanguage.iso)

    this.showCustomizePoster = this.$store.getters.posterIsMutated === false;
  },

  mounted () {
    let h = this.$el.querySelector('.non-latin-warning').clientHeight
    this.nonLatinWarningNaturalHeight = h
    this.loaded = true

    // See if we've received a color prop. Otherwise, default to the first one.
    if (this.selectedColor.name === '') {
      if (this.color) {
        this.selectedColor = this.color
      } else {
        this.selectedColor = this.metaData.colors[0]
      }
    }

    // Now that the poster is loaded, we'll restore transitioning.
    let self = this
    setTimeout(function () {
      self.$el.querySelector('.no-transitions').classList.remove('no-transitions')
    }, 100)

    // Note: this is typically handled in main.js with meta data. However, since the store is updated after the route,
    // we won't be able to set the poster until after the title has been updated, which means that it will always be
    // the previously viewed poster shown in the title, if we handle this route in main.js.
    let title = Translate.translate(this.$route.meta.title)
    title = title.replace('{{poster}}', this.metaData.name)
    title = title.replace('{{artist}}', this.metaData.artist)
    document.title = title

    this.$store.dispatch('trackPosterView', {
      poster: this.metaData,
      color: this.selectedColor,
      list: this.list,
      position: this.position
    })
  },

  computed: {
    amPM: {
      set (value) { this.$store.dispatch('setPosterMeridiem', value) },
      get () { return this.$store.getters.posterMeridiem }
    },

    timeFormat: {
      set (value) { this.$store.dispatch('setPosterMeridiem', value === 24 ? '' : 'am') },
      get () { return this.$store.getters.posterMeridiem === '' ? 24 : 12 }
    },

    artistLinkName () {
      // 'Ingela P. Arrhenius' --> 'ingela-p-arrhenius'
      return this.$store.getters.posterArtist.toLowerCase().replace(/[^a-z0-9\s]/ig, '').replace(/\s/g, '-')
    },

    metaData () {
      let allMetaData = this.$store.getters.postersMetaData
      return allMetaData[this.poster] ? allMetaData[this.poster] : {}
    },

    nonLatinWarningHeight () {
      // If we haven't calculated the height yet, allow us to do so.
      if (!this.loaded) {
        return 'auto'
      }

      // Find out if we have characters outside of the Unicode Latin 1 range (U+00FF).
      let nonLatinCharactersInName = false
      this.birthName.split('').forEach(function (c) {
        if (c.charCodeAt() > 255) {
          nonLatinCharactersInName = true
        }
      })

      if (nonLatinCharactersInName) {
        return this.nonLatinWarningNaturalHeight + 'px'
      }
      return '0'
    },

    birthName: {
      set (value) {
        this.$store.dispatch('setPosterChildName', value)
      },
      get () {
        return this.$store.getters.posterChildName
      }
    },

    unit: {
      set (value) {
        this.$store.dispatch('setPosterUnit', value)
      },
      get () {
        return this.$store.getters.posterUnit
      }
    },

    birthLength: {
      set (value) {
        // Commas are considered decimal separators.
        value = value.replace(',', '.')
        this.$store.dispatch('setPosterLength', value)
      },
      get () {
        return this.$store.getters.posterLength
      }
    },

    grams: {
      set (value) {
        let v = this.$store.getters.posterWeight
        v.grams = value.replace(',', '.')
        this.$store.dispatch('setPosterWeight', v)
      },
      get () {
        return this.$store.getters.posterWeight.grams
      }
    },

    lbs: {
      set (value) {
        let v = this.$store.getters.posterWeight
        v.lbs = value.replace(',', '.')
        this.$store.dispatch('setPosterWeight', v)
      },
      get () {
        return this.$store.getters.posterWeight.lbs
      }
    },

    oz: {
      set (value) {
        let v = this.$store.getters.posterWeight
        v.oz = value.replace(',', '.')
        this.$store.dispatch('setPosterWeight', v)
      },
      get () {
        return this.$store.getters.posterWeight.oz
      }
    },

    birthYear: {
      set (value) {
        let v = this.$store.getters.posterBirthDate
        v.set('year', value)
        this.$store.dispatch('setPosterBirthDate', v)
      },
      get () {
        return parseInt(this.$store.getters.posterBirthDate.format('YYYY'))
      }
    },

    birthMonth: {
      set (value) {
        let v = this.$store.getters.posterBirthDate
        v.month(value)
        this.$store.dispatch('setPosterBirthDate', v)
      },
      get () {
        return parseInt(this.$store.getters.posterBirthDate.month())
      }
    },

    birthDay: {
      set (value) {
        let v = this.$store.getters.posterBirthDate
        v.set('date', value)
        this.$store.dispatch('setPosterBirthDate', v)
      },
      get () {
        return parseInt(this.$store.getters.posterBirthDate.date())
      }
    },

    hour: {
      set (value) {
        let v = this.$store.getters.posterBirthDate
        v.set('hour', value)
        this.$store.dispatch('setPosterBirthDate', v)
      },
      get () {
        return parseInt(this.$store.getters.posterBirthDate.hour())
      }
    },

    minute: {
      set (value) {
        let v = this.$store.getters.posterBirthDate
        v.set('minute', value)
        this.$store.dispatch('setPosterBirthDate', v)
      },
      get () {
        return parseInt(this.$store.getters.posterBirthDate.minute())
      }
    },

    posterColor: {
      set (value) {
        this.$store.dispatch('setPosterColor', value)
      },
      get () {
        return this.$store.getters.posterColor
      }
    },

    price () {
      let prices = this.metaData.prices
      if (prices[this.$store.getters.currency.currency]) {
        return prices[this.$store.getters.currency.currency]
      }
      return prices['SEK'] // @todo Default?
    },

    yearValues () {
      let ret = []
      const currentYear = new Date().getFullYear()
      for (let i = currentYear; i > 1949; i -= 1) {
        ret.push({
          name: i,
          value: i,
          preSelected: i === this.birthYear
        })
      }
      return ret
    },

    monthValues () {
      let ret = []
      let self = this

      // Some languages have objects with formats instead of names, such as Russian. If that's the case, use the
      // "standalone" property, otherwise, use the array.
      let months = this.$store.getters.posterBirthDate.localeData().months()

      months.forEach(function (monthName, index) {
        // Make month name start with an upper-case letter.
        let mn = monthName.substr(0, 1).toUpperCase() + monthName.substr(1)

        // Normalize JavaScript's zero-based months.
        let va = index

        // If this value is the month we've currently selected, set it as pre-selected so we don't alter the value in
        // the form if we change languages.
        let ps = index === self.birthMonth

        ret.push({
          name: mn,
          value: va,
          preSelected: ps
        })
      })
      return ret
    },

    // Return 31 items for selecting the day.
    dayValues () {
      let ret = []
      let sv = this.$store.getters.posterBirthDate.date()
      for (let i = 1; i <= 31; i++) {
        ret.push({ name: i, value: i, preSelected: i === sv })
      }
      return ret
    },

    amPMValues () {
      let hours = this.$store.getters.posterBirthDate.hours()
      let ret = [
        {
          name: 'AM',
          value: 'am',
          preSelected: this.amPM === 'am' || hours < 12
        },
        {
          name: 'PM',
          value: 'pm',
          preSelected: this.amPM === 'pm' || hours > 12
        }
      ]
      return ret
    },

    timeFormatValues () {
      // We can't make the comparisons in the object itself, or Vue's watchers can't see the change.
      let ret = [
        { name: '12h', value: 12, preSelected: this.timeFormat === 12 },
        { name: '24h', value: 24, preSelected: this.timeFormat === 24 }
      ]
      return ret
    }
  },

  methods: {
    getTextTranslated (seed) {
      return Translate.translate(seed)
    },

    setPosterLocale (l) {
      this.$store.dispatch('setPosterLocale', l.value)
    },

    setDay (day) {
      this.birthDay = day.value
    },

    setMonth (month) {
      this.birthMonth = month.value
    },

    setYear (year) {
      this.birthYear = year.value
    },

    setTimeFormat (format) {
      switch (format.value) {
        case 12:
        case 24:
          this.timeFormat = format.value
          break
      }
    },

    setAMPM (amPM) {
      switch (amPM.value) {
        case 'am':
        case 'pm':
          this.amPM = amPM.value
          this.$store.dispatch('setPosterMeridiem', this.amPM)
          break
      }
    },

    setPresentation (p) {
      this.$store.dispatch('setPosterPresentation', p.value)
    },

    setPosterColor (color, index) {
      // Set the local color in the generator.
      this.selectedColor = color

      // Update the store with the color index for the poster.
      this.posterColor = index
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/poster/script.js